const menu = [
  {
    name: "Produkty",
    link: "/produkty",
  },
  {
    name: "Zaufali nam",
    link: "/zaufali-nam",
  },
  {
    name: "Współpraca",
    link: "/współpraca",
  },
  {
    name: "Do pobrania",
    link: "/do-pobrania",
  },
  {
    name: "Kontakt",
    link: "/kontakt",
  },

];

const lang = {
  name: 'en',
  link: 'https://rcmedical.eu/'
}

export { menu, lang };